/**
 * Cham dieu huong cho dai review truot ngang.
 *
 * Doc vi tri tu `scrollLeft` chu khong dem su kien bam: khach vuot tay thi
 * khong co su kien nao de dem, ma vuot moi la cach dung chinh tren dien thoai.
 *
 * KHONG dung IntersectionObserver o day. Da tra gia hai lan trong hai repo
 * khac nhau voi moc cao 0px: observer khong bao cho phan tu khong co dien
 * tich, va hong lang le — van co so lieu, chi la sai. Doc scrollLeft thi
 * khong co cho nao hong lang le duoc.
 */
class ReviewSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-rvs-track]');
    this.dots = [...this.querySelectorAll('.rvs__dot')];
    if (!this.track || !this.dots.length) return;

    // rAF chu khong phai debounce theo thoi gian: cham phai bam theo ngon tay
    // trong luc vuot, cho 100ms thi no giat mot nhip sau khi tay da nha.
    let cho = false;
    this.track.addEventListener('scroll', () => {
      if (cho) return;
      cho = true;
      requestAnimationFrame(() => { cho = false; this.to(); });
    }, { passive: true });

    // Tu chay KHONG nam o day — `assets/tu-truot.js` lo ca ba dai truot
    // cua trang bang mot bo luat. Cham dieu huong o duoi van sang dung vi no
    // nghe su kien `scroll` cua track, ma cuon bang ma cung ban su kien do.

    this.dots.forEach((d) => {
      d.addEventListener('click', () => {
        const slide = this.track.children[Number(d.dataset.i)];
        if (slide) this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
      });
    });
  }

  /** Slide nao dang o giua khung nhin thi cham do sang. */
  to() {
    const giua = this.track.scrollLeft + this.track.clientWidth / 2;
    let gan = 0;
    let min = Infinity;
    [...this.track.children].forEach((el, i) => {
      const d = Math.abs(el.offsetLeft - this.track.offsetLeft + el.offsetWidth / 2 - giua);
      if (d < min) { min = d; gan = i; }
    });
    this.dots.forEach((d, i) => d.classList.toggle('rvs__dot--on', i === gan));
  }
}

if (!customElements.get('review-slider')) customElements.define('review-slider', ReviewSlider);
